import { Box, Button, Flex, Image, Link, Text } from '@chakra-ui/react'
import imageSrc from 'assets/images/insurance-covered-yellow.png'
import { ChakraPrimaryButton } from 'components/Button'
import { RoutePaths } from 'containers/Core/Routes'
import {
  LabType,
  useLabSchedulingContext,
} from 'context/LabSchedulingContext/LabSchedulingProvider'
import { LabProvider } from 'utils/amplitude.types'
import { Amplitude } from 'utils/amplitude.utils'

const LabSelect = () => {
  const {
    setSelectedLab,
    setCurrentScreen,
    amplitudeLabSchedulingMetadata,
  } = useLabSchedulingContext()

  const clickHandler = (labType: LabType) => {
    if (!labType) {
      return
    }

    const amplitudeLabType =
      labType === 'LabCorp' ? LabProvider.LABCORP : LabProvider.QUEST

    Amplitude.labScheduleProviderSelected({
      lab_provider: amplitudeLabType,
      is_reschedule: false,
      source: amplitudeLabSchedulingMetadata.source,
      lab_appointment_id:
        amplitudeLabSchedulingMetadata.lab_appointment_id ?? '',
    })

    setSelectedLab(labType)
    setCurrentScreen('address')
  }

  return (
    <Box
      bg="white"
      p={8}
      borderRadius="lg"
      boxShadow="lg"
      width="sm"
      fontWeight="400"
    >
      <Flex flexDirection="column" alignItems="center" justifyContent="center">
        <Image src={imageSrc} height="66px" width="66px" marginBottom="1rem" />
        <Text fontFamily="Instrument Serif" fontSize="1.5rem">
          Labcorp is our preferred lab partner
        </Text>
        <Text color="#141743">
          Patients who visit Labcorp often get their results faster, giving them
          crucial insights on their health sooner.
        </Text>

        <ChakraPrimaryButton
          width="100%"
          onClick={() => clickHandler('LabCorp')}
        >
          Continue
        </ChakraPrimaryButton>
        <Button
          variant="plain"
          width="100%"
          textDecoration="underline"
          marginTop="2.5rem"
          marginBottom="1rem"
          onClick={() => clickHandler('Quest')}
        >
          Schedule with Quest
        </Button>
        <Text fontSize=".875rem">
          For other lab location options, please{' '}
          <Link
            href={RoutePaths.DASHBOARD_NEW_THREAD}
            color="#4678E6"
            textDecoration="underline"
          >
            message
          </Link>{' '}
          our Concierge team. They can help you with scheduling, or finding a
          lab near you.
        </Text>
      </Flex>
    </Box>
  )
}

export default LabSelect
